<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template
      v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs">

        <md-tab id="tab-account" md-label="Portfolio" :to="recordPath" exact>
          <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
        </md-tab>

     
        <md-tab id="tab-services" md-label="Services" :to="recordPath + '/services'">
          <ElasticList 
            v-if="$route && $route.meta.tab === 'services'" 
            :list.sync="servicesList" 
            :filter="portfolioServicePortfolioId"
            ref="portfolioServicesElasticListRef">
          </ElasticList>

          <md-dialog :md-active.sync="servicesList.showRelatedDialog">
            <md-dialog-title>{{relateServicesList.pageTitle}}</md-dialog-title>
            <md-dialog-content>

              <ElasticList
                v-if="recordData"

                :list.sync="relateServicesList"
                :exclude="relateServicePortfolioFilter"
                :relateRecordInput="{portfolioServiceServiceId: null, portfolioServicePortfolioId: $route.params.id}"
                relateRecordInputField="portfolioServiceServiceId"
              ></ElasticList>

            </md-dialog-content>
            <md-dialog-actions>
              <md-button class="md-theme-default" @click="servicesList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>

        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-layout-item md-small-size-100">
      <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
    </div>


  </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import ElasticList from '@/components/DynamicForm/ElasticList';
  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";

  export default {
    name: "portfolio",
    mixins: [Record],
    computed: { 
      portfolioServicePortfolioId: function() { return {"match": {"portfolioServicePortfolioId": this.$route.params.id }} },
      relateServicePortfolioFilter: function() {
        let result = null;
        if (this.recordData && this.recordData.services && this.recordData.services.items) {
          let items = this.recordData.services.items;
          let filters = [];
          items.forEach(item => {
            filters.push({"match": {"id": item.service.id}});
          });
          if (filters.length) {
            result = {"must_not": filters};
          }
        } 
        return result;
      },
    },
    data() {
      return {
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'portfolioUpdatedById',
          responseFieldName: 'getPortfolio',
          actions: {
            save: 'createPortfolio',
            view: 'editPortfolio',
            edit: 'editPortfolio',
            new: 'getPortfolio',
            update: 'updatePortfolio',
            delete: 'deletePortfolio',
          },
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}},
          },
          listPath: "/portfolios",
          headerIcon: 'folder',
          objectName: 'Portfolio',
          objectNamePlural: 'Portfolios',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          fields: {
            id: { label: "ID", type: "id", slot: 'basic' },
            name: { label: "Name", type: "text", slot: 'basic' },
            description: { label: "Description", type: "text", slot: 'basic' },
            premier: { label: "Premier", type: "checkbox", slot: 'basic' },
          },
          editTitleField: 'name'
        },
        servicesList: {
          refreshData: false,
          showRelatedDialog: false,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "services",
          pageTitle: "Services",
          pageIcon: "style",
          listQueryId: "searchPortfolioServices",
          deleteQueryId: "deletePortfolioService",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Portfolio?",
          deleteMessageText: "",
          deleteMessageNameFields: ['name'],
          columns: {
            'esData.service.name': { label: "Name", sortable: false, searchable: true, esNested: true, },
            'esData.service.description': { label: "Description", sortable: false, searchable: true, esNested: true, },
            'esData.service.createdAt': { label: "Created", sortable: true, searchable: true, esNested: true, }
          },          
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchPortfolioServices && data.searchPortfolioServices.items.length) {
              this.$c.log('formatResponse data', data.items);
              data.searchPortfolioServices.items.forEach((item) => {
                item.relateRecordId = item.id;
                item.id = item.service.id;
                result.push(item);
              })
            }
            return result;
          },
        },
        relateServicesList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "service",
          pageTitle: "Search for Service",
          pageIcon: "style",
          listQueryId: "searchServices",
          createMutationId: "createPortfolioService",
          deleteQueryId: "deletePortfolioService",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAdd"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            createdAt: { label: "Created", sortable: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchServices';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                /** Surface the Service name if it has one */
                item.serviceName = (item && item.name)? item.name : '';
                result.push(item);
              })
            }
            return result;
          },
        },
        subscriptions: {
          'onCreatePortfolioService': {
           
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreatePortfolioService');
              let eventRecord = eventData.value.data.onCreatePortfolioService;
              /** Filter out records that do not apply to the Portfolio we are looking at */
              if (this.recordData.id === eventRecord.portfolio.id) {
                setTimeout(() => {
                  this.$c.log('SUBSCRIPTION MATCH: onCreatePortfolioService');
                  this.$refs.portfolioServicesElasticListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);
              }
            }
          },
          'onDeletePortfolioService': { 
            result: null,
            load: true,
            function: (eventData) => { this.$c.log('on delete portfolio service');
              this.$c.log('SUBSCRIPTION Trigger: onDeletePortfolioService');
              let eventRecord = eventData.value.data.onDeletePortfolioService;
              if (this.recordData.id === eventRecord.portfolio.id) {
                setTimeout(() => {
                  this.$c.log('SUBSCRIPTION MATCH: onDeletePortfolioService');
                  this.$refs.portfolioServicesElasticListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);
              }
            }
          },
        },
        form: {
          id: "",
          name: "",
          premier: "",
          description: "",
        }
      }
    },
    validations() {
      return {
        form: {
          id: {},
          name: {required, minLength: minLength(3)},
          premier: {},
          description: {},
        }
      }
    },
    methods: {
     
    },
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;
    .md-tab-nav-button.md-button {
        color: black !important;

        &.active {
          color: black !important;
          border-bottom: 2px solid black;
        }
      }
    }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

</style>
